/*
* bairun-admin web框架组
*
* */
// import Vue from 'vue'
import './element_lazy'; // 按需加载element

Vue.prototype.$loading = ELEMENT.Loading.service;
Vue.prototype.$message = ELEMENT.Message;
Vue.prototype.$confirm = ELEMENT.MessageBox.confirm;
Vue.prototype.$prompt = ELEMENT.MessageBox.prompt;
ELEMENT.Dialog.props.closeOnClickModal.default = false;
import uploader from 'vue-simple-uploader'; // time line css

import '../../node_modules/timeline-vuejs/dist/timeline-vuejs.css'; // 路由守卫

import Bus from '@/utils/bus'; // 加载网站配置文件夹

import config from './config';
Vue.prototype.$BAIRUN_ADMIN = config; // console.log(config)

Vue.use(Bus);
Vue.use(uploader);
import VConsole from 'vconsole';

if (process.env.NODE_ENV !== 'production') {
  var vConsole = new VConsole();
}

console.log("\n*********************************************************\n     ______          _____ ______  _     _ ______\n    (____  \u2572   \u2571\u2572  (_____|_____ \u2572| |   | |  ___  \u2572\n     ____)  ) \u2571  \u2572    _   _____) ) |   | | |   | |\n    |  __  ( \u2571 \u2571\u2572 \u2572  | | (_____ (| |   | | |   | |\n    | |__)  ) |__| |_| |_      | | |___| | |   | |\n    |______/|______(_____)     |_|\u2572______|_|   |_|\n\n*********************************************************\n\n    \u6B22\u8FCE\u4F7F\u7528\u767E\u6DA6\u7BA1\u7406\u53F0\n");